module.exports = __webpack_public_path__ + "static/media/fuse.db1e12ce.svg";